module.exports = __webpack_public_path__ + "static/media/imgPsd.a995056f.png";